import { add, qs, qsa, remove } from '@fluorescent/dom';
import Delegate from 'ftdomdelegate';
import { Ajaxinate } from 'ajaxinate';

import { section } from '@/neon';
import { emit } from '@/neon/events';
import flyout from '@/lib/filters/flyout';
import filtering from '@/lib/filters/filtering';
import {
  // emit
  removeFilters,
  removeRange,
  clearAll,
  updateFilters,
  // on
  filtersUpdated,
  filtersRemoved,
  rangeRemoved,
  everythingCleared,
} from '@/lib/collection/events';

const selectors = {
  partial: '[data-partial]',
  sort: '[data-sort]'
};

section('search', {
  onLoad() {
    const { searchItemCount } = this.container.dataset;

    if (!parseInt(searchItemCount)) return;
    this.partial = qs(selectors.partial, this.container);
    this.flyout = flyout(this.container);
    this.filterForm = qs('[data-filter-form]', this.container);

    if (this.filterForm) {
      this._initFiltering();
    }
  },

  _initFiltering() {
    // search filters
    this.filtering = filtering(this.container);
    this.partial = qs(selectors.partial, this.container);

    this.subscriptions = [
      filtersRemoved((_, { target }) => {
        this.filtering.removeFilters(target, data => {
          this._renderView(data.url);
        });
      }),

      rangeRemoved(() => {
        this.filtering.removeRange(data => {
          this._renderView(data.url);
        });
      }),

      filtersUpdated((_, { target }) => {
        this.filtering.filtersUpdated(target, data => {
          this._renderView(data.url);
        });
      }),

      everythingCleared(() => {
        this.filtering.clearAll(data => {
          this._renderView(data.url);
        });
      }),
    ];

    this.delegate = new Delegate(this.partial);

    this.delegate.on('click', '[data-remove-filter]', e => {
      e.preventDefault();
      removeFilters([e.target]);
    });

    this.delegate.on('click', '[data-remove-range]', e => {
      e.preventDefault();
      removeRange();
    });

    this.delegate.on('click', '[data-clear]', e => {
      e.preventDefault();
      clearAll();
    });
  },

  _renderView(searchParams) {
    const url = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}&${searchParams}`;
    const loading = qs('.search-template__loading', this.container);

    add(loading, 'is-active');

    fetch(url, { credentials: 'include' })
      .then(res => res.text())
      .then(res => {
        this._updateURLHash(searchParams);
        const doc = new window.DOMParser().parseFromString(res, 'text/html');
        const contents = qs(selectors.partial, doc).innerHTML;
        this.partial.innerHTML = contents;

        remove(loading, 'is-active');
        emit('collection:updated');
      });
  },

  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  },

  onUnload() {
    this.flyout();
    this.filtering();
    this.delegate.off();
    this.subscriptions.forEach(unsubscribe => unsubscribe());
  }
});